module.exports = __webpack_public_path__ + "static/media/are-you-sure.9405f020.png";